import {onFind} from "@elements/init-modules-in-scope";
import {on, addClass, removeClass, findIn} from "@elements/dom-utils";

export function init() {
    onFind(".js-count-characters", function(characters) {
        let input = findIn(".js-count-characters__input", characters);
        let count = findIn(".js-count-characters__counter", characters);

        on("keyup", function(){
            count.innerHTML = input.value.length;
        }, input)
    })
}
